import './index.css';
import { MediaType } from '@umu/umu-types';
// @ts-ignore
import { MediaPlayer } from './mediaPlayer';

const MediaTypes = {
	1: 'image',
	2: 'audio',
	3: 'video',
};
interface IPropsSectionMediaPlayer {
	type: MediaType,
	options:{
		parent:HTMLDivElement|null,
		url:string
	}
}
export default class SectionMediaPlayer{
	constructor(props:IPropsSectionMediaPlayer){
		return new MediaPlayer(MediaTypes[props.type],props.options);
	}
}
